import store from '@/plugins/vuex'

const routes = [
  {
    path: '/artist/my-channels',
    name: 'My Channels',
    beforeEnter(to, from, next) {
      if (
        store.state.auth.user.user_level == 'label_admin' &&
        store.state.artistDashboard.artist_label == null
      ) {
        next({
          name: 'My Artists'
        })
      } else {
        next()
      }
    },
    component: () =>
      import(/* webpackChunkName: 'my-channels-artist' */ './views/Index.vue')
  }
]

export default routes
